import { getOperation, putOperation, postAuth } from "utils/api";

export const queryAgent = async (params) => {
  return await getOperation("/agent/list", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const changePassword = async (params) => {
  return await postAuth("/change-password", {
    ...params,
  });
};

export const updateStatus = async (params) => {
  return await putOperation("/agent", {
    ...params,
  });
};

export const getSuspensionRemarks = async () => {
  return await getOperation("/account-management/remarks");
};
